import { iconConfig } from './iconType'
import { CSSProperties } from 'react'
interface IconProps {
	variant: keyof typeof iconConfig
	className?: string
	style?: CSSProperties
}

export const Icon = ({ variant, className = '', style }: IconProps) => {
	const spritePath = '/assets/icons/default/sprite.svg'

	return (
		<svg className={`${className}`} aria-label={iconConfig[variant].ariaLabel} style={style}>
			<use href={`${spritePath}#${iconConfig[variant].iconPath}`}></use>
		</svg>
	)
}
